// Centralised contact constants + click tracking.
// Update these in one place if support channels ever change.

export const WHATSAPP_NUMBER = "+919115212492";

export const WHATSAPP_PREFILL =
  "Hi Career GPS AI, I need career guidance.";

export const WHATSAPP_URL =
  `https://wa.me/${WHATSAPP_NUMBER.replace(/[^0-9]/g, "")}` +
  `?text=${encodeURIComponent(WHATSAPP_PREFILL)}`;


export const INSTAGRAM_HANDLE = "careergpsaionline";

export const INSTAGRAM_URL =
  `https://instagram.com/${INSTAGRAM_HANDLE}`;


// LinkedIn profile shown on the Contact page.
export const LINKEDIN_URL =
  "https://www.linkedin.com/company/career-gps-ai/";

export const LINKEDIN_HANDLE =
  "Career GPS AI";

export const SUPPORT_EMAIL =
  "helpcareergpsai@gmail.com";

export const EMAIL_SUBJECT =
  "Career GPS AI Support Request";

export const EMAIL_BODY = `Hello Career GPS AI Team,

I need assistance with:

[Please describe your issue here]

Thank you.`;

export const MAILTO_URL =
  `mailto:${SUPPORT_EMAIL}` +
  `?subject=${encodeURIComponent(EMAIL_SUBJECT)}` +
  `&body=${encodeURIComponent(EMAIL_BODY)}`;


// Lightweight analytics — works with Google Analytics (gtag),
// Plausible, or falls back to console.debug.
export function trackContactClick(
  channel,
  source = "unknown"
) {
  const payload = {
    channel,
    source,
    ts: Date.now(),
  };

  try {
    if (typeof window === "undefined") return;

    if (typeof window.gtag === "function") {
      window.gtag("event", "contact_click", {
        event_category: "contact",
        event_label: channel,
        source,
      });
    }

    if (typeof window.plausible === "function") {
      window.plausible("contact_click", {
        props: payload,
      });
    }

    // eslint-disable-next-line no-console
    console.debug(
      "[analytics] contact_click",
      payload
    );
  } catch (err) {
    // Analytics should never block the user experience.
    // eslint-disable-next-line no-console
    console.debug(
      "[analytics] trackContactClick failed",
      err
    );
  }
}
